import _axios from 'axios';
const {localStorage} = window;

let baseURL;

if (window.location.hostname === 'localhost') {
  // For local development
  baseURL = 'http://localhost:4000/api/chat';
} else if (window.location.hostname === 'test.hugo.legal') {
  // For staging environment
  baseURL = 'https://apptest.hugo.legal/api/chat';
} else if (window.location.hostname === 'app.hugo.legal') {
  // For production environment
  baseURL = 'https://admin.hugo.legal/api/chat';
} else {
  // Default or fallback
  baseURL = 'https://admin.hugo.legal/api/chat';
}


class Axios {
  constructor() {
    this.service = _axios.create({
        baseURL,
        withCredentials: true,
    });
    this.service.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    this.service.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  }

  async post(chatbotId, payload = {}, lang = 'en') {
    try {
      const {data} = await this.service.post(`${chatbotId}/${lang}`, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
  async put(path, payload) {
    try {
      const {data} = await this.service.put(path, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
  async get(path, payload) {
    try {
      const {data} = await this.service.get(path);
      return data;
    } catch (error) {
      return error;
    }
  }

  async getData(chatbotId, lang = 'en') {
    try {
      const {data} = await this.service.get(`${chatbotId}/${lang}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  async getCurrentConversation(chatbotId, lang = 'en') {
    try {
      const {data} = await this.service.get(`getCurrentConversation/${chatbotId}/${lang}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  async getBot(chatbotId, lang = 'en') {
    try {
      //const {data} = await this.service.get(`${chatbotId}/${lang}`);
      const {data} = await this.service.get(`getBot/${chatbotId}/${lang}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  async getBotBlocks(chatbotId, lang = 'en') {
    try {
      //const {data} = await this.service.get(`${chatbotId}/${lang}`);
      const {data} = await this.service.get(`getBotBlocks/${chatbotId}`);
      return data;
    } catch (error) {
      return error;
    }
  }
  async getBotMaxProgress(chatbotId, lang = 'en') {
    try {
      const {data} = await this.service.get(`getBotMaxProgress/${chatbotId}`);
      return data;
    } catch (error) {
      return error;
    }
  }


  async emailProg(progurl, email, lang) {
    try {
      const {data} = await this.service.get(`emailProg/${progurl}/${email}/${lang}`);
      return data;
    } catch (error) {
      return error;
    }
  }



  async getBlockData(chatbotId, variable, lang = 'en') {
    try {
      //const {data} = await this.service.get(`${chatbotId}/${lang}`);
      const {data} = await this.service.get(`blockdata/${chatbotId}/${lang}/${variable}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  async getPreviousBlock(chatbotId, blocktype, lang = 'en') {
    try {
      const {data} = await this.service.get(`prev/${chatbotId}/${blocktype}/${lang}`);
      return data;
    } catch (error) {
      return error;
    }
  }
  async getPreviousBlockB(chatbotId, currentId, lang = 'en') {
    try {
      const {data} = await this.service.get(`prev/${chatbotId}/${currentId}/${lang}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  async setNewConversation(chatbotId, lang = 'en') {
    try {
      const {data} = await this.service.post(`setnew/${chatbotId}/${lang}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  async setFirstReplyBlocks(prevBlock, chatbotId, lang = 'en') {
    const payload = [...prevBlock];
    try {
      const {data} = await this.service.post(`set/${chatbotId}/${lang}`, payload);
      return data;
    } catch (error) {
      return error;
    }
  }
  
  async getBlock(chatbotId, blockid, lang = 'en', urlData) {
    try {
      const {data} = await this.service.get(`blockbyid/${chatbotId}/${lang}/${blockid}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  

  async getBlock2(chatbotId, blockid, lang = 'en', urlData) {
    try {
      const {data} = await this.service.get(`block/${chatbotId}/${lang}/${blockid}`);
      return data;
    } catch (error) {
      return error;
    }
  }

  _handleErrors(error) {
    const {status} = error.response;
    switch (status) {
      case 422: {
        return {
          status,
          ...error.response?.data,
        };
      }
      case 404: {
        return {
          status,
          message: error.message,
          error: {},
        };
      }
      case 409: {
        return {
          status,
          ...error.response?.data,
        };
      }
      case 403: {
        return {
          status,
          ...error.response?.data,
        };
      }
      case 401: {
        return {
          status,
          ...error.response?.data,
        };
      }
      default: {
        return {
          status,
          ...error.response?.data,
        };
      }
    }
  }

  _getChatId() {
    if (localStorage) {
      const chatId = localStorage.getItem('id');
      if (chatId) {
        return chatId;
      } else {
        return null;
      }
    }
  }
}
export const axios = new Axios();
